import script from "./QTLiteBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteBody.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteBody.vue?vue&type=style&index=0&id=6d5fba25&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5fba25"]])

export default __exports__